<template>
    <div class="RC_home">
        <div class="g1">
            <div class="g1_cont">
                <p class="p1">国际课程</p>
                <p class="p2">RoSSo College</p>
                <p class="p3">与知名国际学校强强联手，全面发展，全科育人</p>
            </div>
        </div>
        <div class="rc2">
            <div class="section_title">
                <span class="section_cn">什么是 “RoSSo College” ?</span>
                <p class="section_en"></p>
            </div>
            <div class="rc2_cont">
                <p>RoSSo College艺术课程合作项目，由RoSSo国际艺术中心发起，与国内卓越的国际学校合作，在校开设艺术班和艺术公选课。<br><br> RoSSo College基于IGCSE、A
                    Level课程体系，推广艺术课程进校，搭建艺术选修课与学术必修课相融合的课程体系。为学生提供更全面的学科教育，同时为在校学生提供艺术作品集辅导及艺术背景提升活动资源。目标是培养具备全球视野和综合竞争力的高素质人才。
                </p>
            </div>
        </div>
        <div class="rc3">
            <div class="section_title">
                <span class="section_cn">院校合作案例</span>
                <p class="section_en"></p>
            </div>
            <div class="rc3_cont">
                <div class="swiper mySwiperRC1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="rc3_main">
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/6.jpg" alt="">
                                    <div class="rc3_p">
                                        佛山惟德外国语学校
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/1.jpg" alt="">
                                    <div class="rc3_p">
                                        富阳中学国际部
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/2.jpg" alt="">
                                    <div class="rc3_p">
                                        金融街教育集团
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/3.jpg" alt="">
                                    <div class="rc3_p">
                                        橘郡中学
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/4.jpg" alt="">
                                    <div class="rc3_p">
                                        蓝润天使学校
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/5.jpg" alt="">
                                    <div class="rc3_p">
                                        位育中学国际部
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="rc3_main">
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/7.jpg" alt="">
                                    <div class="rc3_p">
                                        兴高级中学国际部
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/8.jpg" alt="">
                                    <div class="rc3_p">
                                        英澳美国际学校
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/9.jpg" alt="">
                                    <div class="rc3_p">
                                        世界外国语中学
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/10.jpg" alt="">
                                    <div class="rc3_p">
                                        平和双语学校
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/11.jpg" alt="">
                                    <div class="rc3_p">
                                        上海中学国际部
                                    </div>
                                </div>
                                <div class="rc3_item">
                                    <img src="../img/rossocollege/12.jpg" alt="">
                                    <div class="rc3_p">
                                        上海赫德璟旻艺术高中
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
        </div>

        <div class="rc4">
            <div class="rc4_cont">
                <div class="swiper mySwiperRC2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="rc4_main">
                                <img src="../img/rossocollege/Mask group-1.jpg" alt="">
                                <div class="right">
                                    <div>
                                        <p class="p1">RoSSo X 南京句容碧桂园学校服装/珠宝时尚艺术课堂</p>
                                        <p class="p2">
                                            RoSSo为南京句容碧桂园学校艺术课堂的支持方以及提供社团指导老师，帮助学生们从眼睛的纪实角度出发，通过多材料尝试，明白常规插画（作为视觉设计素材）的集中记忆点，寻求视觉的突破点。然后，突破常规绘画手法，尝试多方法的手绘。
                                        </p>
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="rc4_btn">立即咨询</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="rc4_main">
                                <img src="../img/rossocollege/Mask group-2.jpg" alt="">
                                <div class="right">
                                    <div>
                                        <p class="p1">RoSSo X 上海位育中学国际部——艺术选修课</p>
                                        <p class="p2">
                                            RoSSo作为上海位育中学国际部的艺术课程合作伙伴，参与设计与搭建艺术选修课程，特别是在高一年级开了一门产品设计课，共有22名学生参与。
                                        </p>
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="rc4_btn">立即咨询</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="rc4_main">
                                <img src="../img/rossocollege/Mask group-3.jpg" alt="">
                                <div class="right">
                                    <div>
                                        <p class="p1">RoSSo X 上海平和双语国际学校——服装艺术社团指导课</p>
                                        <p class="p2">
                                            RoSSo作为上海平和双语国际学校服装艺术社团的校外指导机构，每月不定期到校内参与指导，或者不定期校外，结合疫情也有线上指导等形式帮助平和的学生们完成自己的设计作品。
                                        </p>
                                    </div>

                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="rc4_btn">立即咨询</div>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
                
            </div>
        </div>
        <div class="rc5">
            <div class="section_title">
                <span class="section_cn">课程体系</span>
                <p class="section_en"></p>
            </div>
            <!-- <button @click="generatorImage" >生成图片</button> -->
            <div class="rc5_cont">
                <table ref="printform">
                    <tr style="color: #fff;font-weight: bold;">
                        <td style="width: 180px;background-color: rgb(89, 89, 89);"></td>
                        <td style="width: 180px;background-color: rgb(137, 209, 211);color: #fff;">9年级</td>
                        <td style="width: 180px;background-color: rgb(172, 220, 188);color: #fff;">10年级</td>
                        <td style="width: 180px;background-color: rgb(137, 209, 211);color: #fff;">11年级</td>
                        <td style="width: 180px;background-color: rgb(172, 220, 188);color: #fff;">12年级</td>
                    </tr>
                    <tr>
                        <td rowspan="3"
                            style="color: rgb(89, 89, 89);font-weight: bold;text-align: left;padding-left: 20px;">
                            名师领衔国际课程<br>夯实学术基础</td>
                        <td colspan="2" style="color: rgb(89, 89, 89);font-weight: bold;">iGCSE国际课程</td>
                        <td colspan="2" style="color: rgb(89, 89, 89);font-weight: bold;">A Level文化课程</td>

                    </tr>
                    <tr style="height: 40px;">

                        <td colspan="4">人文、社会科学、科学、工程、体育</td>

                    </tr>
                    <tr style="height: 40px;">

                        <td colspan="4">英文强化课程、托福/雅思等标化考试课程</td>

                    </tr>
                    <!--  -->
                    <tr>
                        <td rowspan="6"
                            style="color: rgb(89, 89, 89);font-weight: bold;text-align: left;padding-left: 20px;">
                            顶尖教育资源<br>培养艺术核心竞争力</td>
                        <td colspan="2" rowspan="2">艺术通识必修课（绘画、艺术史、设计概论等）</td>
                        <td colspan="2" rowspan="2">ALevel艺术专业课程</td>
                    </tr>
                    <tr>



                    </tr>
                    <tr>
                        <td rowspan="2"> </td>
                        <td rowspan="2" colspan="3">专业作品集课程<br>（2D、3D、时尚、传媒、管理等不同专业方向）</td>
                    </tr>
                    <tr>

                    </tr>
                    <tr>
                        <td colspan="4" rowspan="2">
                            （UAL等名校夏校，艺术类行业实训、背景提升资源，全球顶尖艺术比赛等）
                        </td>
                    </tr>
                    <tr>

                    </tr>
                    <!--  -->
                    <tr>
                        <td rowspan="6"
                            style="color: rgb(89, 89, 89);font-weight: bold;text-align: left;padding-left: 20px;">
                            升学规划<br>助力梦校申请</td>
                        <td colspan="2" rowspan="2">目标设定，时间/压力管理、学习习惯</td>
                        <td colspan="2" rowspan="2">升学指导必修课</td>
                    </tr>
                    <tr>

                    </tr>
                    <tr>
                        <td colspan="2" rowspan="2"> </td>
                        <td colspan="2" rowspan="2">专业选择、申请文书、面试辅导</td>
                    </tr>
                    <tr>

                    </tr>
                    <tr>
                        <td colspan="4" rowspan="2">顶尖名校招生官面对面+优秀毕业生分享</td>
                    </tr>
                    <tr></tr>
                    <!--  -->
                    <tr style="">
                        <td rowspan="2"
                            style="color: rgb(89, 89, 89);font-weight: bold;text-align: left;padding-left: 20px;">全人教育创新课
                        </td>
                        <td colspan="4" rowspan="2" >社交情感课程、戏剧、跨学科PBL项目制学习、精英体育课程等</td>
                    </tr>
                    <tr style="border-bottom: 2px solid rgb(165, 165, 158);"></tr>
                </table>
                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                    <div class="rc5_btn">立即咨询</div>
                </a>
            </div>
        </div>
        <div class="rc6">
            <div class="section_title">
                <span class="section_cn">艺术公选课 / 1V1课外拓展</span>
                <p class="section_en"></p>
            </div>
            <div class="rc6_cont">
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1540.jpg" alt="">
                    <div>视觉传达科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1541.jpg" alt="">
                    <div>商科管理科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1542.jpg" alt="">
                    <div>影视电影科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1543.jpg" alt="">
                    <div>建筑空间科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 365.jpg" alt="">
                    <div>工业教务科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1526.jpg" alt="">
                    <div>游戏动画科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1535.jpg" alt="">
                    <div>纯艺插画科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1534.jpg" alt="">
                    <div>FASHION科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1533.jpg" alt="">
                    <div>日本科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1528.jpg" alt="">
                    <div>音乐科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1527.jpg" alt="">
                    <div>国际课程</div>
                </div>
                <div class="rc6_item">

                </div>


            </div>
        </div>
        <div class="rc7">
            <div class="section_title">
                <span class="section_cn">合作办学亮点</span>
                <p class="section_en"></p>
            </div>
            <div class="rc7_cont">
                <div class="rc7_item">
                    • 全面发展、全科育人。培养具备国际竞争力的综合人才
                </div>
                <div class="rc7_item">
                    • 基于IGCSE、A Level课程体系，助力艺术教育在校的推广
                </div>
                <div class="rc7_item">
                    • 可在校完成艺术作品集，一步到位的艺术升学路径
                </div>
                <div class="rc7_item">
                    • 丰富的艺术背景提升活动资源
                </div>
                <div class="rc7_item">
                    • 实行小班教学，因材施教
                </div>
                <div class="rc7_item">
                    • 优质师资，强强联合
                </div>
                <!-- <div class="rc7_item rc7_item7">
                    • 官方合作申请通道，不占UCAS名额
                    <img src="../img/rossocollege/Group 783.png" alt="" class="arrow animated rotateInUpLeft">
                    <div class="imgbox animated fadeInDown">
                        <div class="img1">

                            <img src="../img/rossocollege/image40.jpg" alt="">
                            <p>伯恩茅斯大学<br>官方合作授权书</p>
                        </div>
                        <div class="img2">

                            <img src="../img/rossocollege/image39.jpg" alt="">
                            <p>伦敦艺术大学预科<br>官方合作授权书</p>
                        </div>

                    </div>

                </div> -->

            </div>
        </div>
        <div class="rc8">
            <div class="section_title">
                <span class="section_cn">海外合作院校资源</span>
                <p class="section_en"></p>
            </div>
            <div class="rc8_cont">

                <img class="rc8_item" src="../img/rossocollege/partner/1.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/3.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/4.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/5.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/6.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/7.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/8.jpg" alt="">

                <img class="rc8_item" src="../img/rossocollege/partner/9.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/10.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/11.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/12.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/13.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/14.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/15.jpg" alt="">

                <img class="rc8_item" src="../img/rossocollege/partner/16.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/17.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/18.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/19.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/20.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/21.jpg" alt="">
                <img class="rc8_item" src="../img/rossocollege/partner/22.jpg" alt="">
            </div>
        </div>

        <img class="rc9" src="../img/rossocollege/Group 782.png" alt="">

        <div class="v3">
            <div class="v3_cont">
                <div class="swiper mySwiperV1">
                    <div class="v3_title">
                        <p>国际师资团队 >></p>
                        <div class="v3_btn" @click="toggleV3(0)">#海外教授</div>
                        <div class="v3_btn" @click="toggleV3(1)">#海归导师</div>
                    </div>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in teacherData">
                            <div class="v3_item" v-for="(item2, index2) in item" @click="teacherDetail(item2.id)">
                                <div class="img_box">
                                    <img :src="'https://public.rossoarts.com/static/uploads/teacher/' + item2.avatar"
                                        alt="">
                                </div>
                                <span class="p1">{{ item2.school | schoolAll }}</span>
                                <h2>{{ item2.name | fliterName }}</h2>
                                <p class="p2">{{ item2.major }}</p>
                                <p class="p3">{{ item2.school | schoolSplit }}</p>
                            </div>

                        </div>

                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>

            </div>

        </div>
        <div class="rc9">
            <div class="rc9_cont">
                <div class="rc9_left">

                    <div class="rc9_left_main">

                        <div class="swiper mySwiperRC3">
                            <div class="rc9_title">
                                <p>优秀升学案例 >></p>
                            </div>
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <P class="p1">Wang 同学</P>
                                    <div>
                                        <p><span>A Level成绩：</span>摄影A，纺织A，中文A</p>
                                        <p><span>BTEC：</span>Distinction</p>
                                        <p><span>申请专业：</span>珠宝设计</p>
                                        <p><span>录取结果：</span>伦敦艺术大学中央圣马丁艺术与设计学院、伦敦艺术大学伦敦时装学院、爱丁堡大学</p>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <P class="p1">Li 同学</P>
                                    <div>
                                        <p><span>A Level成绩：</span>纯艺A*，经济A，心理A</p>
                                        <p><span>标化：</span>托福115</p>
                                        <p><span>Rosso作品集：</span>服装设计</p>
                                        <p><span>录取结果：</span>帕森斯设计学院（奖学金：48000美金）</p>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <P class="p1">Fan 同学</P>
                                    <div>
                                        <p><span>A Level成绩：</span>纯艺-A，中文A*, 数学A，经济A</p>
                                        <p><span>标化：</span>雅思6.5</p>
                                        <p><span>申请专业：</span>数字媒体</p>
                                        <p><span>录取结果：</span>伦敦大学国王学院，伦敦艺术大学，多伦多大学、墨尔本大学、阿姆斯特丹大学</p>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <P class="p1">Zheng 同学</P>
                                    <div>
                                        <p><span>A Level成绩：</span>纺织A，摄影A，中文A</p>
                                        <p><span>Rosso作品集：</span>服装设计</p>
                                        <p><span>录取结果：</span>伦敦艺术大学</p>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <P class="p1">Wang 同学</P>
                                    <div>
                                        <p><span>A Level成绩：</span>纯艺预估A，中文预估A，数学A，物理A</p>
                                        <p><span>BTEC：</span>Distinction</p>

                                        <p><span>录取结果：</span>伦敦艺术大学</p>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <P class="p1">Zhang 同学</P>
                                    <div>
                                        <p><span>A Level成绩：</span>纯艺A，摄影预估A，中文A</p>
                                        <p><span>Rosso作品集：</span>电影</p>
                                        <p><span>录取结果：</span>伦敦大学金匠学院、爱丁堡大学、布里斯托大学</p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-button-next"></div>
                            <div class="swiper-button-prev"></div>
                        </div>
                    </div>
                </div>
                <div class="rc9_right">

                    <div class="swiper mySwiperRC4">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img src="../img/rossocollege/image1.jpg" alt="">
                            </div>
                            <div class="swiper-slide">
                                <img src="../img/rossocollege/image2.jpg" alt="">
                            </div>
                            <div class="swiper-slide">
                                <img src="../img/rossocollege/image3.jpg" alt="">
                            </div>
                            <div class="swiper-slide">
                                <img src="../img/rossocollege/image4.jpg" alt="">
                            </div>
                            <div class="swiper-slide">
                                <img src="../img/rossocollege/image5.jpg" alt="">
                            </div>
                            <div class="swiper-slide">
                                <img src="../img/rossocollege/image6.jpg" alt="">
                            </div>
                        </div>
                        <div class="swiper-button-next" style="visibility: hidden;"></div>
                        <div class="swiper-button-prev" style="visibility: hidden;"></div>
                    </div>
                </div>
            </div>

        </div>

        <div class="section_inp" style="margin-top: 180px;">
            <div class="s_inp_left">
                <img src="../img/shouchahua.png" alt="" class="img_shou  wow rotateInDownLeft" id="imgShou">
                <img src="../img/rossocollege/Group 690.png" alt="" class="img_text  wow rollIn" id="imgText" style="margin-left:-10px">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="150px" :model="formLabelAlign">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="意向专业：" class="elitem2">
                        <el-select v-model="formLabelAlign.region" placeholder="选择意向专业">
                            <el-option label="服装设计" value="服装设计"></el-option>
                            <el-option label="景观设计" value="景观设计"></el-option>
                            <el-option label="工业设计" value="工业设计"></el-option>
                            <el-option label="插画设计" value="插画设计"></el-option>
                            <el-option label="动画设计" value="动画设计"></el-option>
                            <el-option label="建筑设计" value="建筑设计"></el-option>
                            <el-option label="交互设计" value="交互设计"></el-option>
                            <el-option label="室内设计" value="室内设计"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="请输入电话号码"></el-input>
                    </el-form-item>
                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="选择意向国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>

                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="意向专业：">
                    <el-input v-model="formLabelAlign.major" placeholder="请输入意向专业"></el-input>
                </el-form-item> -->
                    <el-form-item class="yuyue_box">
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <!--  -->
    </div>
</template>
<script>

// ********************
var _self
import Swiper from 'swiper/bundle'
import html2canvas from "html2canvas";
import { Controller } from '../assets/js/controller.js';
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import 'swiper/css';
import "swiper/css/effect-flip";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import axios from "axios"
import "@/assets/css/Rossocollege.css"
export default {
    comments: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            teacherData: [],
            category: 2,
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                major: '',
            },
            labelPosition: 'right',
        }
    },
    beforeCreate() {
        _self = this;
    },
    filters: {
        fliterName(val) {
            // console.log(val, _self.category);
            return _self.category == 1 ? val : "Prof." + val
        },
        schoolAll(val) {
            return val.split(",")[1]
        },
        schoolSplit(val) {
            return val.split(",")[0]
        },
    },
    created() {
        this.getTeacherData()
    },
    methods: {
    generatorImage() {
            html2canvas(this.$refs.printform, {
                allowTaint: true,
                taintTest: false,
                useCORS: true,
                dpi: window.devicePixelRatio * 4, //将分辨率提高到特定的DPI 提高四倍
                scale: 2, //按比例增加分辨率
            }).then((canvas) => {
                let link = document.createElement("a");
                link.href = canvas.toDataURL("image/jpeg", 1.0); //下载链接
                link.setAttribute(
                    "download",
                    `test.png`
                );
                link.style.display = "none"; //a标签隐藏
                document.body.appendChild(link);
                link.click();
            });
        },
        onSubmit() {
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            // console.log('submit!',this.formInline);
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "major": this.formLabelAlign.major,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status":status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        mySwiperV1Init() {
            new Swiper('.mySwiperV1', {
                loop: true,
                observe: true,
                observeParents: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },

            })
        },
        teacherDetail(val) {
            this.$router.push(`/teachers/${val}.html`)
        },
        getTeacherData() {
            axios.get(`https://public.rossoarts.com/api/v1/getFirstTeacher?category=${this.category}&limit=12`).then((data) => {
                // console.log(data.data);
                this.teacherData = this.arrGroup(data.data, 4)
                // console.log(this.teacherData);
                this.$nextTick(() => {
                    this.mySwiperV1Init()
                })
            })
        },
        toggleV3(val) {
            // console.log(val);
            var v3_btn = document.getElementsByClassName("v3_btn")
            for (var i = 0; i < v3_btn.length; i++) {
                v3_btn[i].style.color = "#000"
                v3_btn[i].style.borderColor = "#000"
            }
            v3_btn[val].style.color = "#FB6333"
            v3_btn[val].style.borderColor = "#FB6333"
            if (val == 0) {
                this.category = 2
            } else {
                this.category = 1
            }
            this.getTeacherData()
        },
        rc7handle() {
            var arrow = document.getElementsByClassName("arrow")
            arrow[0].classList.add("rotateInUpLeft")

        },
        // jopkefu() {
        //     window.open("", "_blank")
        // },
        mySwiperRC1Init() {
            new Swiper('.mySwiperRC1', {
                loop: true,

                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },


            })
        },
        mySwiperRC2Init() {
            new Swiper('.mySwiperRC2', {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            })
        },
        // mySwiperRC3Init() {
        //     var myRC3 = new Swiper('.mySwiperRC3', {
        //         loop: false,
               
        //         navigation: {
        //             nextEl: ".swiper-button-next",
        //             prevEl: ".swiper-button-prev",
        //         },
        //     })
        // },
        mySwiperRC4Init() {
            var MyRC3 = new Swiper('.mySwiperRC3', {
                loop: true,
                controller: {
                    control: MyRC4, //控制Swiper2
                },
               
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
            var MyRC4 = new Swiper('.mySwiperRC4', {
                loop: true,
                controller: {
                    control: MyRC3, //控制Swiper1
                },
                
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            })

            MyRC3.controller.control = MyRC4;
            MyRC4.controller.control = MyRC3;


        },
    },
    mounted() {

        // console.log(this.mySwiperRC4Init);
        this.mySwiperRC1Init()
        this.mySwiperRC2Init()
        // this.mySwiperRC3Init()
        this.mySwiperRC4Init()
        this.mySwiperV1Init()


    }
}
</script>